import React from "react";
import PropTypes from "prop-types";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import Dialog from "@material-ui/core/Dialog";
import AddBeaconForm from "./AddBeaconForm";

const AddBeaconDialog = ({ open, onSave, onCancel, submitting }) => {
  return (
    <Dialog open={open} fullWidth maxWidth={"sm"}>
      <DialogTitle>Dodanie beacon </DialogTitle>
      <DialogContent>
        <AddBeaconForm
          onCancel={onCancel}
          submitting={submitting}
          handleSubmit={onSave}
        />
      </DialogContent>
    </Dialog>
  );
};

AddBeaconDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onSave: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  dispatch: PropTypes.func,
  submitting: PropTypes.bool.isRequired,
};

export default AddBeaconDialog;
